module.exports = __webpack_public_path__ + "images/article-bg.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/article-bg.png
// module id = 859
// module chunks = 0